module.exports = __webpack_public_path__ + "img/dundees-inner-city.2c2b6647.jpg";